import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../app/store";
import { useState } from "react";
import { addLacreManifesto, removerLacreManifesto } from "../../../features/manifestoSlice";
import { Link } from "react-router-dom";
import { JConfirmDelete, MensagemModal } from "../../../components/Components";
import { LacresManifestoInterface, SelectObjectRemoveInterface } from "../../../interfaces";
import { getUuidV4 } from "../../../utils/utils";

const initialForm: LacresManifestoInterface = {
    id: 0,
    numero: ''
}

const initialSelect: SelectObjectRemoveInterface = {
    id: 0,
    title: ''
}

export default function LacresManifesto() {
    const dispatch = useDispatch();
    const lista = useSelector((state: RootState) => state.manifesto.manifesto.lacres);
    const [form, setForm] = useState<LacresManifestoInterface>(initialForm);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [selected, setSelected] = useState<SelectObjectRemoveInterface>(initialSelect);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [messageAlert, setMessageAlert] = useState<string>('');

    const alerta = (message: string) => {
        setMessageAlert(message);
        setShowAlert(true)
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(initialSelect);
    }

    const handleOpenModal = (value: SelectObjectRemoveInterface) => {
        setSelected(value);
        setShowModal(true);
    }

    const validarPreenchimento = () => {
        if (form.numero.trim() === "") {
            alerta('Informe o número do lacre.');
            return false;
        }

        if (lista.find((item: LacresManifestoInterface) => item.numero === form.numero)) {
            alerta('Número do lacre já foi adicionado.');
            return false;
        }
        return true;
    }

    const handleAdd = () => {
        if (validarPreenchimento()) {
            dispatch(addLacreManifesto({
                id: getUuidV4(),
                numero: form.numero
            }));
            setForm(initialForm)
        }
    }

    const handleRemove = (id: number | string) => {
        dispatch(removerLacreManifesto(id));
        setShowModal(false);
    }

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    return <div className="px-2">

        <Row className="g-2 mb-3">
            <Col md={2} className="">
                <Form.Group >
                    <Form.Label>Número do lacre</Form.Label>
                    <Form.Control placeholder="" maxLength={60} type="text"
                        value={form.numero} name="numero" onChange={handleChange}
                    />
                </Form.Group>
            </Col>

            <Col md className="d-flex align-items-end">
                <Form.Group>
                    <Button variant="primary" onClick={handleAdd}>
                        <FontAwesomeIcon icon={faPlus} />  Adicionar
                    </Button>
                </Form.Group>
            </Col>
        </Row>

        <Table striped bordered hover size="sm">
            <thead className="table-light">
                <tr>
                    <th className="text-center" style={{ width: '2.5rem' }}>#</th>
                    <th>Número do lacre</th>
                </tr>
            </thead>

            <tbody>
                {lista.map((item: LacresManifestoInterface) => (
                    <tr key={item.id}>
                        <td className="text-center">
                            <Link to={''} className="text-danger"
                                onClick={() => handleOpenModal({ id: item.id, title: item.numero })}>
                                <FontAwesomeIcon icon={faTrash} />
                            </Link>
                        </td>
                        <td>{item.numero}</td>
                    </tr>
                ))}
            </tbody>
        </Table>

        <JConfirmDelete
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            handleDelete={handleRemove}
            selectedObject={selected.title}
            id={selected.id}
        />

        <MensagemModal
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            mensagem={messageAlert}
        />

    </div>
}